import { render } from "./linkGroup.vue?vue&type=template&id=70a93826&scoped=true"
import script from "./linkGroup.vue?vue&type=script&lang=js"
export * from "./linkGroup.vue?vue&type=script&lang=js"

import "./linkGroup.vue?vue&type=style&index=0&id=70a93826&scoped=true&lang=css"

import exportComponent from "D:\\svn test\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70a93826"]])

export default __exports__